import getConfig from 'next/config';

import { getCookie } from '!app/lib/cookies';

export const HULU_ONE_TRUST_GROUP = 'C0004';
export const OPTANON_CONSENT_COOKIE_ID = 'OptanonConsent';

const buildOneTrustProps = (isOneTrustConsentSyncEnabled) => {
  const oneTrustConfig = getConfig().publicRuntimeConfig.oneTrust;

  const legacySrc = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  const scriptSrc = isOneTrustConsentSyncEnabled
    ? oneTrustConfig.sdkUrl
    : legacySrc;

  return {
    scriptSrc,
    guuid: oneTrustConfig.guuid,
  };
};

export const createOtScript = (isOneTrustConsentSyncEnabled) => {
  const { scriptSrc, guuid } = buildOneTrustProps(isOneTrustConsentSyncEnabled);

  const otScriptElement = document.createElement('script');

  otScriptElement.setAttribute('id', 'ot-script');
  otScriptElement.setAttribute('src', scriptSrc);
  otScriptElement.setAttribute('data-testid', 'ot-script');
  otScriptElement.setAttribute('data-domain-script', guuid);
  otScriptElement.setAttribute('data-document-language', 'true');
  otScriptElement.setAttribute('type', 'text/javascript');
  otScriptElement.setAttribute('charset', 'UTF-8');

  return otScriptElement;
};

export const createOtScriptObj = (isOneTrustConsentSyncEnabled) => {
  const { scriptSrc, guuid } = buildOneTrustProps(isOneTrustConsentSyncEnabled);

  return {
    stubSDK: scriptSrc,
    guuid,
  };
};

export function isOptanonConsentCookieSetForHulu() {
  const optanonConsentCookie = getCookie(OPTANON_CONSENT_COOKIE_ID);

  if (
    optanonConsentCookie &&
    optanonConsentCookie.includes(`${HULU_ONE_TRUST_GROUP}:1`)
  ) {
    return true;
  }
  return false;
}

export function isOptanonConsentCookieSet() {
  const optanonConsentCookie = getCookie(OPTANON_CONSENT_COOKIE_ID);

  return Boolean(optanonConsentCookie);
}
